import { useDroppable } from '@dnd-kit/core';
import React, { PropsWithChildren } from 'react';

import { IconButton } from '@eika/button';
import { IconTypes } from '@eika/icon';

import useTranslation from '../../../../../../../../hooks/useTranslation';
import { HeaderInput } from './HeaderInput';

import './GroupHeader.scss';

type Props = {
    id: string;
    name: string;
    onEdit(name: string): void;
    onDelete(name: string): void;
    onChange(name: string): void;
    mode: 'edit' | 'display';
    removable: boolean;
};

export const GroupHeader = ({
    id,
    name,
    onEdit,
    onChange,
    mode = 'display',
    onDelete,
    removable,
}: PropsWithChildren<Props>) => {
    const translated = useTranslation();
    const { setNodeRef } = useDroppable({ id });

    const onClick = () => {
        onEdit(id);
    };

    const onRemove = () => {
        onDelete(id);
    };

    return (
        <li className="group-header" ref={setNodeRef}>
            {mode === 'display' && (
                <>
                    <h4 className="group-header__title">{name}</h4>
                    <IconButton
                        screenReaderText={translated.editAccounts.change}
                        data-testid="edit-contact-info-link"
                        onClick={onClick}
                        icon={IconTypes.PENN_24}
                    />
                </>
            )}
            {mode === 'edit' && (
                <>
                    <HeaderInput name={name} onChange={onChange} />
                    {removable && (
                        <IconButton
                            screenReaderText={translated.editAccounts.remove}
                            data-testid="edit-contact-info-link"
                            onClick={onRemove}
                            icon={IconTypes.SLETT_24}
                        />
                    )}
                </>
            )}
        </li>
    );
};
